import { putResolve, put } from 'redux-saga/effects';
import { REQUEST } from '@piconetworks/pkg-network-middleware';
import { IFRAMELY_API_URL } from '@piconetworks/pkg-endpoints';

function getUrlMetadata(_ref) {
  var duck = _ref.duck,
    _ref$linkUrl = _ref.linkUrl,
    linkUrl = _ref$linkUrl === void 0 ? null : _ref$linkUrl;
  return function* () {
    try {
      if (!linkUrl) {
        throw new Error('Must provide url to fetch!');
      }
      var url = IFRAMELY_API_URL(linkUrl);
      var _yield$putResolve = yield putResolve({
          type: REQUEST,
          config: {
            method: 'get',
            url: url,
            timeout: 30000,
            headers: {
              Accept: 'application/json'
            }
          }
        }),
        data = _yield$putResolve.data;
      if (data) {
        yield put({
          type: duck.types.GET_URL_METADATA_SUCCESS,
          payload: {
            linkUrl: linkUrl,
            data: data
          }
        });
      } else {
        yield put({
          type: duck.types.GET_URL_METADATA_ERROR,
          error: error
        });
      }
    } catch (error) {
      console.log(error);
      yield put({
        type: duck.types.GET_URL_METADATA_ERROR,
        error: error
      });
    }
  }();
}

export { getUrlMetadata as default };
//# sourceMappingURL=getUrlMetadata.js.map
